import { CORAL } from '../tokens'

interface ChinniMascotProps {
  size?: number
  /** 'smile' for normal/idle state, 'thinking' while Chinni is composing a reply. */
  expression?: 'smile' | 'thinking'
}

/**
 * Chinni as an actual drawn character instead of a chat-bubble icon --
 * simple, cheap to render everywhere Chinni appears (dashboard card, chat
 * entry points, "thinking" waiting states). Deliberately minimal so it reads
 * clearly at small sizes (nav bar) as well as large ones (hero).
 */
export function ChinniMascot({ size = 44, expression = 'smile' }: ChinniMascotProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: CORAL,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 0 rgba(0,0,0,.18)',
        flexShrink: 0,
      }}
    >
      <svg width={size * 0.5} height={size * 0.5} viewBox="0 0 24 24" fill="none">
        <circle cx="8.5" cy="10" r="1.4" fill="#fff" />
        <circle cx="15.5" cy="10" r="1.4" fill="#fff" />
        {expression === 'smile' ? (
          <path d="M8 15c1.2 1.3 2.6 2 4 2s2.8-.7 4-2" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" />
        ) : (
          <circle cx="12" cy="16" r="1.4" fill="#fff" />
        )}
      </svg>
    </div>
  )
}
